import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { theme } from '../theme';
import { MATERIAL_LOCALES } from './locales';
import { useUiLanguage } from './useUiLanguage';

/**
 * The app theme with MUI's own texts in the current language - pagination, "No options",
 * the clear button on an Autocomplete. Rebuilt on a language switch, which is the only time
 * it changes.
 *
 * Files that import `theme` directly for a value (a palette colour, a typography variant)
 * keep doing so: those values do not depend on language.
 */
const LocalizedThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const language = useUiLanguage();
  const localized = useMemo(() => createTheme(theme, MATERIAL_LOCALES[language]), [language]);
  return <ThemeProvider theme={localized}>{children}</ThemeProvider>;
};

export default LocalizedThemeProvider;
